import { divisionClient, employerClient } from 'apis';
import { DivisionViewModel, EmployerViewModel } from 'apis/nswag';

// Simple in-memory cache for employers
export let cachedEmployers: EmployerViewModel[] | null = null;
let cachePromise: Promise<EmployerViewModel[]> | null = null;

export let cachedDivisions: DivisionViewModel[] | null = null;
let cacheDivPromise: Promise<DivisionViewModel[]> | null = null;

export const fetchEmployers = async (): Promise<EmployerViewModel[]> => {
  if (cachedEmployers) return cachedEmployers;
  if (cachePromise) return cachePromise;
  cachePromise = employerClient.getEmployers('', [], 0, 0, undefined).then((res) => {
    cachedEmployers = res.rows || [];
    return cachedEmployers;
  });
  return cachePromise;
};

export const fetchDivisions = async (): Promise<DivisionViewModel[]> => {
  if (cachedDivisions) return cachedDivisions;
  if (cacheDivPromise) return cacheDivPromise;
  cacheDivPromise = divisionClient.getDivisions([], '', [], 5000, 0, undefined).then((res) => {
    cachedDivisions = res.rows || [];
    return cachedDivisions;
  });
  return cacheDivPromise;
};
